import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map } from 'lodash';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';

import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { getLabel } from 'utils/getLabel';
import { MemberPrescriptionDetailSummary } from 'ui/containers/MemberPrescriptionDetailSummary';
import { MemberPrescriptionRefillsWidget } from 'ui/containers/MemberPrescriptionRefillsWidget';
import { MemberPrescriptionClaimsWidget } from 'ui/containers/MemberPrescriptionClaimsWidget';

// widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.PRESCRIPTION_DETAILS_SUMMARY ]: MemberPrescriptionDetailSummary,
    [ WIDGET_NAMES.PRESCRIPTION_DETAILS_REFILLS ]: MemberPrescriptionRefillsWidget,
    [ WIDGET_NAMES.PRESCRIPTION_DETAILS_CLAIMS ]: MemberPrescriptionClaimsWidget
};


const _memberPrescriptionDetail = ( props ) => {

    return (
        <div className='ui-member-prescription-detail'>
            <div className='ui-member-prescription-detail__action'>
                {
                    map( props.navActions, navAction => {

                        // get the action for navAction
                        const icondId = 'back' === navAction.name ? 'backArrow': null;

                        return (
                            <div className='ui-member-prescription-detail__action__navaction' key={ navAction.name }
                                onClick={ () => props.onNavActionClick( { type: 'headerAction', value: navAction } ) }
                            >
                                <Icon id={ icondId } />
                                <div className='ui-member-prescription-detail__action__navaction__label'>{ getLabel( navAction.title ) }</div>
                            </div>
                        );

                    } )
                }
            </div>

            {/* widget sequence view */}
            <div className='ui-member-prescription-detail__widgets'>
                {
                    map( props.widgets, widget => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        // widget class name
                        const widgetClassName = classnames( 'ui-member-prescription-detail__widgets__widget' );

                        return (
                            <div key={ widget.name } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    memberId={ props.memberId }
                                    onDependentSwitch={ props.onDependentSwitch }
                                    requestPayload={ props.requestPayload }
                                />
                            </div>
                        );
                    } )
                }
                
            </div>
        </div>
    );
};

// set display name
_memberPrescriptionDetail.displayName = 'memberPrescriptionDetail';

// set default props
_memberPrescriptionDetail.defaultProps = {};

// prop types
_memberPrescriptionDetail.propTypes = {};

// preloader view
export const memberPrescriptionDetailPreloader = () => {
    return (
        <div className='ui-member-details-widget-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
memberPrescriptionDetailPreloader.displayName = 'memberPrescriptionDetailPreloader';

// set default props
memberPrescriptionDetailPreloader.defaultProps = {};

// prop types
memberPrescriptionDetailPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberPrescriptionDetail as MemberPrescriptionDetail } from 'ui/views/widgets/memberPrescriptionDetail';
 *
 * // render
 * <MemberPrescriptionDetail propName='propValue'/>
 */
export const memberPrescriptionDetail = withNetworkState( memberPrescriptionDetailPreloader, _memberPrescriptionDetail );
